import React, { useEffect, useState } from 'react';
import { storeConfig } from '../../config/config';
import './storeDetails.scss';
import '../message/message.scss';
import { Button, makeStyles } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import LaunchIcon from '@material-ui/icons/Launch';

type storeDetailProps = {
  store: any,
  isHostDevice: boolean
}


const useStyles = makeStyles({
  button1: {
    backgroundColor: '#FFFFFF',
    color: '#305233',
    textTransform: 'none',
    fontStyle: 'normal',
    borderTop: '1px solid #305233',
    borderLeft: '1px solid #305233',
    borderRight: '1px solid #305233',
    borderBottom: '1px solid #305233',
    borderRadius: '2px',
    fontSize: '14px',
    letterSpacing: '0.08em',
    lineHeight: '21px',
    width: '100%',
    transition: 'all .2s ease',
    '&:hover': {
      backgroundColor: '#F8F8F8',
      color: '#305233',
    },
    '&:focus': {
      backgroundColor: '#F8F8F8',
      color: '#305233',
      border: '2px solid #5795DB'
    },
    '&:active': {
      backgroundColor: '#F3F3F3',
      color: '#474947',
      border: 'none'
    }
  }
})

const StoreDetails = ({ store, isHostDevice }: storeDetailProps) => {
  const classes = useStyles();
  const [timeStr1, timeStr2] = store?.data?.store_trading_hours?.map((x: { tradingStatus: any }) => ({ "simpleTradingstatus": x.tradingStatus })) ?? ['', ''];

  const getDirection = () => {
    window.open(`${storeConfig.GOOGLE_MAP_API_DIRECTION_URL}${store.data.division}, ${store.data.addressLine1}, ${store.data.suburb}`, '_blank');
  }

  const theme = createTheme({
    typography: {
      button: {
        textTransform: "none",
        fontSize: 14,
        fontFamily: "din-2014",
        letterSpacing: "0.08em"
      }
    }
  });

  const renderTradingHours = (store: { data: { store_trading_hours: any[]; }; }) => {
    return (
      <div className='store__week-status'>
        {store?.data?.store_trading_hours?.map((day, index) => {
          return renderTradingHour(day, index);
        })}
      </div>
    );
  }

  const renderTradingHour = (day: { day: string | any[]; openHour: string; }, index: React.Key | null | undefined) => {
    if (index !== 0 && index !== 7) {
      return (
        <div className="store__trading-Hours" key={index}>
          <div className="store__trading-Hours__day">
            <span>
              {day.day}
            </span>
          </div>
          <span className="store__trading-Hours__openHour">
            {day.openHour.toLowerCase() !== "closed" ? (
              <div>
                <span className="store__trading-Hours__openHour-time">
                  {day.openHour}
                </span>
              </div>
            ) : ("Closed")}
          </span>
        </div>
      );
    } else {
      return null;
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <div className='store'>
        <div className='store__location'>
          <div className='store__title'>
            {<span className='store__suburb'>
              {storeConfig.DAN_MURPHY_CELLAR_STORE_SUBURB.includes(store.data.suburb?.toLowerCase())
                ? `${storeConfig.DAN_MURPHY_CELLAR_STORE}${store.data.suburb?.toLowerCase()}`
                : store.data.suburb?.toLowerCase()}
            </span>}
            {store.data.distance && <div className='store__distance'>{store.data.distance}km</div>}
          </div>
          <div className='store__address'>{store.data.addressLine1}</div>
          <div className='store__address'><span className='store__suburb'>{store.data.suburb.toLowerCase()}</span> {store.data.postcode}</div>
        </div>
        <div className={'store__hours ' + (isHostDevice && 'store__hours--device')} >
          <div className='store__date'>
            <span className={timeStr1.simpleTradingstatus?.[0] === 'Closed now' ? 'store__status-today-closed' : 'store__status-today-open'}>
              <b>{timeStr1.simpleTradingstatus?.[0]}</b>
            </span>
            <span className='store__opening-hours'>
              {timeStr2.simpleTradingstatus && ''} {timeStr1.simpleTradingstatus?.[1]} {timeStr1.simpleTradingstatus?.[2]}
            </span>
          </div>
        </div>
        {renderTradingHours(store)}
        <div className='store__options'>
          <Button id="get-direction-link" size='small' className={classes.button1} style={{ fontWeight: 600, padding: '8px 24px 8px 21px', letterSpacing: 'initial' }} disableRipple={true} onClick={getDirection} endIcon={<LaunchIcon fontSize="inherit" />}>Get directions</Button>
        </div>
      </div>
    </ThemeProvider>
  );
}

export {
  StoreDetails
}